import { useEffect } from 'react';
import LocalStorageService from '../../services/local-storage';
import useIntegrationErrorsStore from './store';

const useIntegrationErrors = () => {
  const errorsCount = useIntegrationErrorsStore(
    (state) => state.totalErrorsCount,
  );
  const loadErrors = useIntegrationErrorsStore((state) => state.loadErrors);
  const hasLoaded = useIntegrationErrorsStore((state) => state.hasLoaded);
  const isLoading = useIntegrationErrorsStore((state) => state.isLoading);
  const loadError = useIntegrationErrorsStore((state) => state.loadError);

  useEffect(() => {
    const hasApiHostUrl = !!LocalStorageService.getItem('apiHostUrl');
    const hasToken = !!LocalStorageService.getItem('user')?.token;

    if (!hasApiHostUrl || !hasToken) {
      return;
    }

    if (hasLoaded || isLoading || loadError) {
      return;
    }

    loadErrors({}).catch((error) => {
      console.error(error);
    });
  }, [hasLoaded, isLoading, loadError, loadErrors]);

  return {
    errorsCount,
    loadErrors,
    hasLoaded,
    isLoading,
    loadError,
  };
};

export default useIntegrationErrors;
